import { BASE_DEV_URL, CONFIG } from '../../config/api.config';
import axios from 'axios';
import { setSupport } from './support.slice';


export const requestSupport = () => async(dispatch, getState) => {
    const auth = getState().auth;
    
    if(!!auth) {
        try{
            const data = {
                siteurl: CONFIG.siteurl
            }
    
            const response = await axios.post(BASE_DEV_URL + 'getUserWpNumber', data, {
                headers: {
                    Authorization: `Bearer ${auth}`
                }
            });
            if(!!response?.data?.success) {
                dispatch(setSupport(response?.data?.data))
            }

        }catch(err) {
            console.log('Support error: ', err.message);
        }
    }else {
        try {
            const data = {
                siteurl: CONFIG.siteurl
            }
    
            const response = await axios.post(BASE_DEV_URL + 'getWpNumber', data);
            if(!!response?.data?.success) {
                dispatch(setSupport(response?.data?.response))
            }
    
        }catch(err) {
            console.log('Support error: ', err.message);
        }
    }

}